import React from 'react';
const IconCommentConvoFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 7V16.5H12.17L9.22998 20H13.03L14.71 22H17V20H23V7H18.5Z" fill="#2D2E2E"/>
<path d="M17 15V2H1V15H7V18H8.95L11.47 15H17Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentConvoFill;